import { useState } from "react";
import { useMediaQuery } from "react-responsive";
import DesktopBudgetStatus from "./desktop/DesktopBudgetStatus";

export default function BudgetStatusContainer() {
    const isMobile = useMediaQuery({
        query: "(max-width: 599px)"
    });

    return (
        <div>
            {!isMobile && <DesktopBudgetStatus />}
            {isMobile && <div style={{ padding: "20px", textAlign: "center" }}>Mobile version coming soon</div>}
        </div>
    );
}
